<template>
  <div class="navComponent">
    <nav class="navbar navbar-inverse navbar-expand-lg" style="margin-bottom: 2%;">
      <div class="container-fluid">
        <div class="navbar-header">
          <router-link class="navbar-brand" to="/" id="nav-logo">
            <img src="../assets/logo.png" alt="meetbeans logo" style="width: 200px;" />
          </router-link>
        </div>
        <button
          class="navbar-toggler btn-primary"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerMenu"
          aria-controls="navbarTogglerMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fas fa-bars navbar-toggler-icon" style="font-size: 25px;"></i>
        </button>
        <div class="collapse navbar-text navbar-collapse" id="navbarTogglerMenu">
          <ul class="nav navbar-nav ml-auto mt-lg-0 text-cen">
            <li>
              <router-link
                to="/"
                class="text-primary"
                style="margin: 10px;display:flex;"
                id="nav-home"
              >
                <b>Home</b>
              </router-link>
            </li>
            <li class>
              <a
                href="javascript:void(0)"
                class="text-primary"
                style="display:flex;margin: 10px;"
                data-toggle="modal"
                data-target="#channelName"
                id="nav-video-call-with-login"
                v-if="login"
              >
                <b>Create Event</b>
              </a>
              <a
                href="javascript:void(0)"
                class="text-primary"
                style="display:flex;margin: 10px;"
                data-toggle="modal"
                data-target="#channelName"
                id="nav-video-call-without-login"
                v-else
              >
                <b>Create Event</b>
              </a>
            </li>
            <li class>
              <router-link
                to="/dashboard"
                id="nav-dashboard-with-login"
                class="text-primary"
                style="display:flex;margin: 10px;"
                v-if="login"
              >
                <b>Dashboard</b>
              </router-link>
            </li>
            <li>
              <div class="dropdown" id="nav-profile" style="display:flex;" v-if="login">
                <div class="dropdown-toggle text-primary" data-toggle="dropdown">
                  <div>
                    <img
                      v-if="userData.photoURL !== ''"
                      :src="userData.photoURL"
                      style="width: 40px; height: 40px; border-radius: 25px;"
                      alt
                    />
                    <img
                      v-else
                      src="https://img.pngio.com/user-logos-user-logo-png-1920_1280.png"
                      style="width: 40px; height: 40px;border-radius: 25px;"
                      alt
                    />
                    <span>
                      <b>{{userData.name.split(' ')[0]}}</b>
                    </span>
                  </div>
                </div>
                <ul class="dropdown-menu dropdown-menu-right bg-secondary">
                  <!--			            <li><router-link to="/dashboard" style="display: flex; margin: 10px;"><b>Dashboard</b></router-link></li>-->
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="logout"
                      class="text-primary"
                      id="nav-logout"
                      style="display:flex;margin: 10px;"
                    >
                      <b>Logout</b>
                    </a>
                  </li>
                </ul>
              </div>
              <div style="display:flex;margin: 10px;"
                v-else>
                <router-link
                to="/signup"
                href="javascript:void(0)"
                class="text-primary"
                id="nav-signup-modal"
              >
                <b>
                  Login /
                </b>
              </router-link>
              <router-link
                to="/register"
                href="javascript:void(0)"
                class="text-primary ml-1"
                id="nav-signup-modal"
              >
                <b>
                   Register
                </b>
              </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div
      class="modal"
      id="loginModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="loginModal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Login</h5>
            <button class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class id="close-login">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <br />
            <button
              @click="socialLogin('google')"
              class="btn btn-block btn-default btn-dark"
              style="display: flex; justify-content: center"
              id="google-signup"
              data-dismiss="modal"
              data-toggle="modal"
              aria-label="Close"
            >
              <img
                alt="Google Logo"
                src="../assets/google-logo.png"
                class="mr-1"
                style="width: 40px;"
              />
              <span style="font-weight: bold; font-size: 18px; margin-top: 5px;">Login with Google</span>
            </button>
            <br />
            <h6>
              <span>or</span>
            </h6>
            <router-link
              to="/signup"
              style="display: flex; justify-content: center"
              class="btn btn-block btn-default btn-dark"
              data-dismiss="modal"
              data-toggle="modal"
              aria-label="Close"
            >
              <span style="font-size: 25px; margin: 2px 10px;">
                <b>
                  <i class="fas fa-envelope-open"></i>
                </b>
              </span>
              <span style="font-weight: bold; font-size: 18px; margin-top: 7px;">Login with Email</span>
            </router-link>
            <button
              @click="socialLogin('twitter')"
              class="btn btn-block btn-default d-none"
              style="background: #007bff;display: flex; justify-content: center"
              id="twitter-signup"
            >
              <img
                alt="Google Logo"
                src="../assets/twitter-logo.png"
                class="mr-1"
                style="width: 40px;"
              />
              <span
                style="font-weight: bold; font-size: 18px; margin-top: 5px; color: #fff;"
              >Login with Twitter</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="channelName"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createEvent"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content" v-if="login">
          <div class="modal-header">
            <h5 class="modal-title" v-if="quickEvent">Quick Event</h5>
            <h5 class="modal-title" v-else-if="scheduleEvent">Schedule Event</h5>
            <h5 class="modal-title" v-else>Create Event</h5>
            <button class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class id="meeting-close">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="quickEvent">
              <a href="javascript:void(0)" @click="quickEvent=false">
                <i class="fas fa-arrow-left"></i> Back
              </a>
              <div class="container" style>
                <div class="form-group text-left" style="margin: 2% 10%;">
                  <label>Event Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="nav-channel"
                    min="1"
                    max="50"
                    placeholder="Event Name"
                    v-model="channelName"
                  />
                </div>
                <div class="form-group text-left" style="margin: 2% 10%;">
                  <div style="display: flex; justify-content: space-between">
                    <div id="participants-info">
                      <span>
                        <label>Participants</label>
                        <i class="fas fa-info-circle"></i>
                      </span>
                      <div
                        class="tooltip-text"
                        style="background-color: #101010; border: 1px solid; border-radius: 10px; color: #fff; font-size: 12px;"
                      >
                        <b>Instruction</b>
                        <ul style="text-align: left;">
                          <li>This will be for arranging tables with 4 chairs in each table. Please consider 20% extra participant on your maximum expected participants.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <input
                    type="number"
                    class="form-control"
                    min="1"
                    id="nav-participants"
                    placeholder="Number of participants"
                    v-model="participants"
                  />
                </div>
                <div class="form-group" style="margin: 2% 10%;">
                  <label>Select the purpose</label>
                  <select class="form-control" v-model="purpose" required id="meeting-purpose">
                    <option value="customer_engagement">Customer Engagement</option>
                    <option value="remote_teams">Remote Working Teams</option>
                    <option value="classrooms">Remote Classrooms</option>
                    <option value="others">Others</option>
                  </select>
                  <input
                    type="text"
                    v-if="purpose==='others'"
                    class="form-control mt-2"
                    id="meeting-other-purpose"
                    placeholder="please mention other..."
                    v-model="otherPurpose"
                  />
                </div>
                <div class="text-center">
                  <button
                    type="submit"
                    @click="submitChannelName"
                    id="submit-channel-name"
                    class="btn btn-primary"
                  >Create Quick Event</button>
                </div>
              </div>
            </div>
            <div v-else-if="scheduleEvent" style="color: #a9a9a9">
              <!--						  <a href="javascript:void(0)" @click="scheduleEvent=false"><i class="fas fa-arrow-left"></i> Back</a>-->
              <div style="margin: 16%; text-align: center">
                <p>
                  <b>For creating schedule event first you have to create new organization from your dashboard from side panel.</b>
                </p>
                <router-link
                  to="/dashboard"
                  data-dismiss="modal"
                  aria-label="Close"
                  class="btn btn-outline-primary"
                >Dashboard</router-link>
              </div>
            </div>
            <div
              v-else
              class="container"
              style="color: #a9a9a9; display: flex;align-items: center;margin: 40px 0;"
            >
              <div class="row">
                <div class="col-12 col-sm-6 text-center">
                  <svg
                    width="150"
                    height="150"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <image
                      href="../assets/quick-event.svg"
                      style="color: #fbaf28 !important;"
                      width="150"
                      height="150"
                    />
                  </svg>
                  <h5>
                    <b>Quick Event</b>
                  </h5>
                  <p
                    style="font-weight: lighter"
                  >This is event will create a single auditorium for you.</p>
                  <button class="btn btn-primary" @click="quickEvent=true">Create</button>
                </div>
                <div class="col-12 col-sm-6 text-center">
                  <svg
                    width="150"
                    height="150"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <image
                      href="../assets/schedule-event.svg"
                      style="color: #fbaf28 !important;"
                      width="150"
                      height="150"
                    />
                  </svg>
                  <h5>
                    <b>Schedule Event</b>
                  </h5>
                  <p
                    style="font-weight: lighter"
                  >This is event will create a multiple auditorium for you.</p>
                  <button class="btn btn-primary" @click="scheduleEvent=true">Create</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-content" v-else>
          <div class="modal-header">
            <h5 class="modal-title">To create event, please login</h5>
            <button class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class id="meeting-close">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <br />
            <button
              @click="socialLogin('google')"
              class="btn btn-block btn-default btn-dark"
              style="display: flex; justify-content: center"
              id="google-signup"
            >
              <img
                alt="Google Logo"
                src="../assets/google-logo.png"
                class="mr-1"
                style="width: 40px;"
              />
              <span style="font-weight: bold; font-size: 18px; margin-top: 5px;">Login with Google</span>
            </button>
            <br />
            <h6>
              <span>or</span>
            </h6>
            <router-link
              to="/signup"
              style="display: flex; justify-content: center"
              class="btn btn-block btn-default btn-dark"
              data-dismiss="modal"
              data-toggle="modal"
              aria-label="Close"
            >
              <span style="font-size: 25px; margin: 2px 10px;">
                <b>
                  <i class="fas fa-envelope-open"></i>
                </b>
              </span>
              <span style="font-weight: bold; font-size: 18px; margin-top: 7px;">Login with Email</span>
            </router-link>
            <button
              @click="socialLogin('twitter')"
              class="btn btn-block btn-default d-none"
              style="background: #007bff;display: flex; justify-content: center"
              id="twitter-signup"
            >
              <img
                alt="Google Logo"
                src="../assets/twitter-logo.png"
                class="mr-1"
                style="width: 40px;"
              />
              <span
                style="font-weight: bold; font-size: 18px; margin-top: 5px; color: #fff;"
              >Login with Twitter</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
// import Login from "./login";
// @ is an alias to /src
export default {
  name: "navComponent",
  components: {},
  data() {
    return {
      login: false,
      userData: {
        name: "",
        email: "",
        photoURL: "",
        phoneNumber: "",
        user_type: "",
        designation: "NA",
        location: "",
        company: "NA",
        credential: {},
        is_admin: false,
      },
      channelName: "",
      participants: 1,
      purpose: "",
      otherPurpose: "",
      quickEvent: false,
      scheduleEvent: false,
    };
  },
  created() {
    this.checkUser();
  },
  methods: {
    showSignupModal() {
      //   this.$root.$emit('openSignupModal')
      // console.log("clicked show");
      this.$refs.modal.show();
    },
    submitUserInfo: function () {
      this.$store.dispatch("insertUser", this.userData).then((resp) => {
        if (resp.data.status === "success") {
          this.login = true;
          localStorage.setItem("user_info", JSON.stringify(resp.data.data));
          this.$toast.open({
            message: "Login successful, create or join any event.",
            type: "success",
			position: "top",
			queue: true
          });
          let data = {
            name: this.userData.name,
            email: this.userData.email,
            number: this.userData.phoneNumber,
            photoURL: this.userData.photoURL,
          };
          var event_name = "Login Form";
          window.freshsales.trackEvent(event_name, data);
          location.reload();
          // this.$router.push("/dashboard");
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
			position: "top",
			queue: true
          });
        }
      });
    },
    submitChannelName: function () {
      let data = {
        channel_name: this.channelName,
        participants: this.participants,
        purpose: this.purpose === "others" ? this.otherPurpose : this.purpose,
      };
      if (this.participants >= 1) {
        if (this.channelName !== "" && this.purpose !== "") {
          let format = /^[A-Za-z0-9 ]+$/;

          if (!format.test(this.channelName)) {
            this.$toast.open({
              message: "Meeting name can't contain special characters.",
              type: "error",
			  position: "top",
			  queue: true
            });
          } else if (this.channelName.length >= 50) {
            this.$toast.open({
              message: "Meeting name should not have more than 50 words",
              type: "error",
			  position: "top",
			  queue: true
            });
          } else {
            this.$store.dispatch("getMeetID", data).then((resp) => {
              if (resp.data.status === "success") {
                let id = resp.data.data;
                document.getElementById("meeting-close").click();
                this.$router.push("/event/" + data.channel_name + "/" + id);
              }
            });
          }
        } else {
          this.$toast.open({
            message: "Meeting name & purpose can't be empty",
            type: "error",
			position: "top",
			queue: true
          });
        }
      } else {
        this.$toast.open({
          message: "Please check the value of participants",
          type: "error",
		  position: "top",
		  queue: true
        });
      }
    },
    checkUser: function () {
      if (localStorage.getItem("user_info")) {
        this.login = true;
        this.userData = JSON.parse(localStorage.getItem("user_info"));
        let data = {
          email: firebase.auth().currentUser.email,
          uid: this.userData.uid,
        };
        this.$store.dispatch("getUserInfo", data).then((resp) => {
          if (resp.data.status === "success") {
            this.userData = JSON.parse(localStorage.getItem("user_info"));
          }
        });
      } else {
        this.login = false;
      }
    },
    logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.login = false;
          localStorage.removeItem("user_info");
          this.$router.push("/signup");
        });
    },
    socialLogin(provider) {
      let providerAuth = "";
      if (provider === "google") {
        providerAuth = new firebase.auth.GoogleAuthProvider();
      } else if (provider === "twitter") {
        providerAuth = new firebase.auth.TwitterAuthProvider();
      }
      firebase
        .auth()
        .signInWithPopup(providerAuth)
        .then((result) => {
          // call an api here to store information in Mongodb Se
          this.userData = {
            name: result.user.displayName,
            email: result.user.email,
            photoURL: result.user.photoURL,
            phoneNumber: result.user.phoneNumber,
            user_type: "audience",
            company: "NA",
            designation: "NA",
            is_admin: false,
            location: "",
            credential: result.credential,
            token: "",
            city: "",
            country: "",
            bio: "Hey, I'm using meetbeans.",
            fb_url: "",
            twitter_url: "",
            linkedin_url: "",
          };
          this.submitUserInfo();
        })
        .catch((err) => {
          alert("Oops. " + err.message);
        });
    },
  },
};
</script>
<style scoped>
h6 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid rgb(87, 81, 81);
  line-height: 0.1em;
  margin: 10px 0 20px;
}

h6 span {
  background: #1b1b1b;
  padding: 0 10px;
}
.dropdown-toggle:after {
  content: none;
}
#participants-info {
  position: relative;
  margin-top: 5px;
  cursor: pointer;
}

#participants-info .tooltip-text {
  visibility: hidden;
  width: 370px;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
  position: absolute;
  left: -10px;
  top: -60px;
  z-index: 1;
}
.tooltip-text {
  margin-top: -55px;
}
#participants-info:hover .tooltip-text {
  visibility: visible;
}
</style>
